// @ts-strict

import { Directive, Output, EventEmitter, ElementRef, HostListener, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Directive to detect if user has clicked outside component
 */

@Directive({
  selector: '[appClickOutsideComponent]'
})
export class ClickOutsideComponentDirective {
  @Input() dontActivateIfModal = false;
  @Output() clickOutside = new EventEmitter<HTMLElement | void>();

  constructor(private elementRef: ElementRef, private readonly modalService: NgbModal) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement): void {
    const modalActive = this.modalService.hasOpenModals();
    const clickedInside = this.elementRef.nativeElement.contains(target);

    if (!clickedInside && !this.dontActivateIfModal) {
      this.clickOutside.emit(target);
    }
    if (!clickedInside && this.dontActivateIfModal) {
      if (
        !modalActive &&
        !target.parentElement?.className.includes('modal') &&
        !target.parentElement?.className.includes('preview-container') &&
        !target.className.includes('close-button') &&
        !target.parentElement?.className.includes('close-button')
      ) {
        this.clickOutside.emit(target);
      }
    }
  }
}
